import React from 'react'

import { Cta } from './cta'

export type Props = {
  items: readonly (Queries.CtaFragment | null)[]
  isBgDark?: boolean
}
const Ctas: React.FC<Props> = ({ items, isBgDark = false }) =>
  items.map((cta, index) => {
    if (cta === null) return null
    const color = index % 2 === 0 ? 'primary' : 'secondary'
    return (
      <Cta
        key={`${cta.text}-${cta.originalId}`}
        {...cta}
        color={color}
        isBgDark={isBgDark}
      />
    )
  })

export default Ctas
